import { create } from "zustand";
import { persist } from "zustand/middleware";

const STORAGE_KEY = "investmashina_selected_branch";

interface BranchStore {
  selectedBranchId: string | null;
  selectedBranchName: string | null;
  setSelectedBranch: (
    branchId: string | null,
    branchName: string | null
  ) => void;
  clearSelectedBranch: () => void;
}

export const useBranchStore = create<BranchStore>()(
  persist(
    (set) => ({
      selectedBranchId: null,
      selectedBranchName: null,
      setSelectedBranch: (branchId, branchName) => {
        set({ selectedBranchId: branchId, selectedBranchName: branchName });
      },
      clearSelectedBranch: () => {
        set({ selectedBranchId: null, selectedBranchName: null });
      },
    }),
    {
      name: STORAGE_KEY,
    }
  )
);

// Selector hooks for optimized re-renders
export const selectSelectedBranchId = (state: BranchStore) =>
  state.selectedBranchId;
export const selectSelectedBranchName = (state: BranchStore) =>
  state.selectedBranchName;
export const selectSetSelectedBranch = (state: BranchStore) =>
  state.setSelectedBranch;
export const selectClearSelectedBranch = (state: BranchStore) =>
  state.clearSelectedBranch;

// Backward compatibility hook
export const useBranchContext = () => {
  const selectedBranchId = useBranchStore(selectSelectedBranchId);
  const selectedBranchName = useBranchStore(selectSelectedBranchName);
  const setSelectedBranch = useBranchStore(selectSetSelectedBranch);
  const clearSelectedBranch = useBranchStore(selectClearSelectedBranch);

  return {
    selectedBranchId,
    selectedBranchName,
    setSelectedBranch,
    clearSelectedBranch,
  };
};

// Helper function to get selected branch ID synchronously
export const getSelectedBranchId = (): string | null => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const { state } = JSON.parse(stored);
      return state?.selectedBranchId || null;
    }
  } catch (error) {
    console.error("Error getting branch selection:", error);
  }
  return null;
};
